<template>
  <Layout>
    <div class="festival-info-container animate-fade-in">
      <!-- Page Header -->
      <header class="header-wrapper mb-4">
        <div>
          <PageHeader :title="title" :items="breadcrumbs" class="p-0 m-0 border-0" />
        </div>
      </header>

      <!-- Bento Grid Form Layout -->
      <!-- Bento Grid Form Layout -->
      <form @submit.prevent="handleSubmit" ref="formContainer" class="bento-grid-form">
        <div class="bento-layout-grid">

          <!-- BENTO CARD 1: BẢN SẮC THƯƠNG HIỆU (Spans 8 cols) -->
          <section class="bento-card bento-col-8 bento-bg-light">
            <div class="card-header-premium">
              <span class="isax isax-crown icon-primary"></span>
              <h3 class="card-title-premium">Bản sắc &amp; Nhận diện Thương hiệu</h3>
            </div>

            <div class="bento-card-body">
              <!-- Tên gọi Lễ hội (Song ngữ) -->
              <div class="row">
                <div class="col-md-6 form-group-premium mb-3">
                  <label class="form-label-premium">Tên gọi Lễ hội chính thức (VI) <span
                      class="text-danger">*</span></label>
                  <input v-model="model.tenGoi" type="text" class="premium-input font-bold text-primary"
                    placeholder="Ví dụ: LỄ HỘI TRÁI CÂY ĐỒNG THÁP LẦN THỨ I..." required />
                </div>
                <div class="col-md-6 form-group-premium mb-3">
                  <label class="form-label-premium">Tên gọi Lễ hội tiếng Anh (EN)</label>
                  <input v-model="model.tenGoiEn" type="text" class="premium-input font-bold text-primary"
                    placeholder="Example: THE 1st DONG THAP FRUIT FESTIVAL..." />
                </div>
              </div>

              <!-- Tên hiển thị hệ thống & Chủ đề song ngữ -->
              <div class="row">
                <div class="col-md-4 form-group-premium mb-3">
                  <label class="form-label-premium">Tên hiển thị hệ thống <span class="text-danger">*</span></label>
                  <input v-model="model.name" type="text" class="premium-input"
                    placeholder="Nhập tên hiển thị rút gọn..." required />
                </div>

                <div class="col-md-4 form-group-premium mb-3">
                  <label class="form-label-premium">Chủ đề chính (VI) <span class="text-danger">*</span></label>
                  <input v-model="model.chuDe" type="text" class="premium-input italic text-secondary"
                    placeholder="Ví dụ: Đồng Tháp – Miền trái ngọt" required />
                </div>

                <div class="col-md-4 form-group-premium mb-3">
                  <label class="form-label-premium">Chủ đề chính (EN)</label>
                  <input v-model="model.chuDeEn" type="text" class="premium-input italic text-secondary"
                    placeholder="Example: Dong Thap – Land of Sweet Fruits" />
                </div>
              </div>
            </div>
          </section>

          <!-- BENTO CARD 2: QUY MÔ & THỜI GIAN (Spans 4 cols) - Màu vàng kem nhạt -->
          <!-- STREAMING_CHUNK:Rendering the stats and duration block... -->
          <section class="bento-card bento-col-4 bento-bg-cream">
            <div class="card-header-premium">
              <span class="isax isax-calendar-1 icon-primary"></span>
              <h3 class="card-title-premium">Thời gian &amp; Quy mô</h3>
            </div>

            <div class="bento-card-body d-flex flex-column justify-content-between h-100 pb-2">
              <!-- Thời gian diễn ra song ngữ -->
              <div class="form-group-premium mb-2">
                <label class="form-label-premium">Thời gian (VI) <span class="text-danger">*</span></label>
                <div class="input-icon-wrapper">
                  <span class="isax isax-clock input-inner-icon"></span>
                  <input v-model="model.thoiGian" type="text" class="premium-input ps-5"
                    placeholder="Ví dụ: Ngày 05-08/6/2026" required />
                </div>
              </div>
              <div class="form-group-premium mb-2">
                <label class="form-label-premium">Thời gian (EN)</label>
                <div class="input-icon-wrapper">
                  <span class="isax isax-clock input-inner-icon"></span>
                  <input v-model="model.thoiGianEn" type="text" class="premium-input ps-5"
                    placeholder="Example: June 05-08, 2026" />
                </div>
              </div>

              <!-- Quy mô song ngữ -->
              <div class="form-group-premium mb-2">
                <label class="form-label-premium">Quy mô (VI) <span class="text-danger">*</span></label>
                <input v-model="model.quyMo" type="text" class="premium-input" placeholder="Ví dụ: Cấp tỉnh..."
                  required />
              </div>
              <div class="form-group-premium m-0">
                <label class="form-label-premium">Quy mo (EN)</label>
                <input v-model="model.quyMoEn" type="text" class="premium-input"
                  placeholder="Example: Provincial level..." />
              </div>
            </div>
          </section>

          <!-- BENTO CARD 3: HÌNH ẢNH BANNER SLIDER (Spans 4 cols, Chạy dọc cao) -->
          <!-- STREAMING_CHUNK:Rendering the images and slider upload box... -->
          <section class="bento-card bento-col-4 bento-row-span-2">
            <div class="card-header-premium">
              <span class="isax isax-gallery text-primary mr-2"></span>
              <h3 class="card-title-premium">Ảnh Slider Trang Chủ</h3>
            </div>

            <div class="bento-card-body d-flex flex-column h-100">
              <p class="text-muted text-xs mb-3 text-left">
                Tải lên danh sách ảnh portrait cho Slider carousel hiển thị trực quan tại trang chủ.
              </p>

              <!-- Hidden input file -->
              <input type="file" ref="imageFileInput" class="d-none" accept="image/*" multiple
                @change="handleImageUpload" />

              <!-- Trigger Upload Box Bento-style -->
              <div class="upload-trigger-box-custom mb-3" @click="triggerImageSelect">
                <span class="isax isax-import icon-upload mb-2"></span>
                <span class="upload-text-custom">Tải ảnh lên</span>
                <span class="upload-hint-custom">Hỗ trợ JPG, PNG, WEBP</span>
              </div>

              <!-- Grid hiển thị danh sách ảnh bento nhỏ hơn -->
              <div v-if="model.hinhAnh && model.hinhAnh.length > 0" class="bento-image-grid-scroll">
                <div v-for="(img, idx) in model.hinhAnh" :key="idx" class="bento-image-item shadow-xs">
                  <div class="image-thumb-box">
                    <img :src="getImageUrl(img)" class="img-thumb" alt="Uploaded Thumbnail" />
                  </div>
                  <div class="image-meta-info text-left">
                    <span class="image-filename text-truncate" :title="img.fileName">
                      {{ img.fileName || 'Image' }}
                    </span>
                    <span class="image-extension-tag">{{ img.ext || 'jpg' }}</span>
                  </div>
                  <button type="button" class="btn-remove-image-custom" @click="removeImage(idx)" title="Xoá ảnh này">
                    <span class="isax isax-close-1"></span>
                  </button>
                </div>
              </div>

              <div v-else class="empty-images-placeholder">
                <span class="isax isax-image placeholder-icon"></span>
                <p>Chưa có hình ảnh nào được tải lên.</p>
              </div>
            </div>
          </section>

          <!-- BENTO CARD 4: BẢN ĐỒ & ĐỊA ĐIỂM (Spans 5 cols) -->
          <!-- STREAMING_CHUNK:Rendering location block... -->
          <section class="bento-card bento-col-5">
            <div class="card-header-premium">
              <span class="isax isax-location icon-primary"></span>
              <h3 class="card-title-premium">Địa điểm tổ chức</h3>
            </div>

            <div class="bento-card-body">
              <div class="form-group-premium mb-3">
                <label class="form-label-premium">Địa điểm tổ chức (VI) <span class="text-danger">*</span></label>
                <textarea v-model="model.diaDiem" class="premium-input" rows="3"
                  placeholder="Nhập địa điểm tổ chức chi tiết tiếng Việt..." required></textarea>
              </div>
              <div class="form-group-premium m-0">
                <label class="form-label-premium">Địa điểm tổ chức (EN)</label>
                <textarea v-model="model.diaDiemEn" class="premium-input" rows="3"
                  placeholder="Example: Hung Vuong Square, Ward Dao Thanh..."></textarea>
              </div>
            </div>
          </section>

          <!-- BENTO CARD 5: CẤU HÌNH VẬN HÀNH & PUBLIC (Spans 3 cols) - Màu xanh nhạt -->
          <section class="bento-card bento-col-3 bento-bg-sage d-flex flex-column justify-content-between">
            <div class="card-header-premium">
              <span class="isax isax-setting-2 icon-primary"></span>
              <h3 class="card-title-premium">Vận hành</h3>
            </div>

            <div class="bento-card-body d-flex flex-column justify-content-between h-100 pb-2">
              <!-- Switch Trạng thái hiển thị công khai -->
              <div class="form-group-premium mb-4 text-left">
                <label class="form-label-premium">Trạng thái phát hành</label>
                <div class="custom-control custom-switch premium-switch-custom mt-2">
                  <input type="checkbox" class="custom-control-input" id="isPublicSwitch" v-model="model.isPublic" />
                  <label class="custom-control-label label-switch-text cursor-pointer" for="isPublicSwitch">
                    Hiển thị lên Trang chủ
                  </label>
                </div>
              </div>

              <!-- Cụm hành động Lưu/Tải lại dạng Dashboard -->
              <div class="action-buttons-stack space-y-2 w-100">
                <button type="submit" class="btn-save-premium-dashboard" :disabled="isSaving">
                  <i v-if="isSaving" class="fas fa-spinner fa-spin mr-1"></i>
                  <span v-else class="isax isax-archive-book me-1"></span>
                  Lưu cấu hình
                </button>

                <button type="button" class="btn-reload-premium-dashboard" @click="fetchData">
                  <span class="isax isax-rotate-left me-1"></span>
                  Tải lại dữ liệu
                </button>
              </div>
            </div>
          </section>

        </div>
      </form>
    </div>


  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import { siteInfoModel } from "@/models/profession/siteInfo/siteInfoModel";
import axios from "axios";

export default {
  name: "ThongTinLeHoi",
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Cấu hình thông tin lễ hội",
      breadcrumbs: [
        {
          text: "Hệ thống",
          href: "#",
        },
        {
          text: "Thông tin lễ hội",
          active: true,
        },
      ],
      model: siteInfoModel.baseJson(),
      isSaving: false,
      defaultId: "6a0ed2080120714c361437e0",
      apiView: process.env.VUE_APP_API_URL + 'filesminio/view/',
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // Fetch existing settings
    async fetchData() {
      const loader = this.$loading.show({ container: this.$el });
      try {
        const res = await this.$store.dispatch("profession/infoSite/infoSiteStore/getSiteInfo");
        if (res && res.code === 0 && res.data) {
          this.model = siteInfoModel.fromJson(res.data);
        } else {
          // If no existing data in database, initialize model with the default ID
          this.model = siteInfoModel.baseJson();
          this.model._id = this.defaultId;
        }
      } catch (error) {
        console.error("Error loading site info:", error);
        this.$store.dispatch("snackBarStore/addNotify", {
          code: -1,
          message: "Không thể tải dữ liệu cấu hình lễ hội.",
        });
      } finally {
        loader.hide();
      }
    },

    // Trigger file dialog
    triggerImageSelect() {
      this.$refs.imageFileInput.click();
    },

    // Handle files upload
    async handleImageUpload(event) {
      if (event.target && event.target.files.length > 0) {
        const files = event.target.files;
        const loader = this.$loading.show({ container: this.$el });
        try {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const formData = new FormData();
            formData.append("files", file);
            const response = await axios.post(`${process.env.VUE_APP_API_URL}filesminio/Upload`, formData);
            const resultData = response.data;
            if (resultData.code === 0 && resultData.data) {
              if (!this.model.hinhAnh) {
                this.$set(this.model, "hinhAnh", []);
              }
              this.model.hinhAnh.push({
                fileId: resultData.data.fileId,
                fileName: resultData.data.fileName,
                ext: resultData.data.ext,
                path: resultData.data.path,
              });
            }
          }
          this.$store.dispatch("snackBarStore/addNotify", {
            code: 0,
            message: "Tải ảnh lên thành công!",
          });
        } catch (error) {
          console.error("Error uploading images:", error);
          this.$store.dispatch("snackBarStore/addNotify", {
            code: -1,
            message: "Đã xảy ra lỗi trong quá trình tải ảnh lên.",
          });
        } finally {
          this.isSaving = false;
          loader.hide();
          this.$refs.imageFileInput.value = "";
        }
      }
    },

    // Remove image from list
    removeImage(index) {
      this.model.hinhAnh.splice(index, 1);
    },

    // Resolve URL path
    getImageUrl(file) {
      if (!file) return "";
      if (file.fileId) return this.apiView + file.fileId;
      return file.path || "";
    },

    // Submit configuration
    async handleSubmit() {
      this.isSaving = true;
      const loader = this.$loading.show({ container: this.$refs.formContainer });
      try {
        if (!this.model._id) {
          this.model._id = this.defaultId;
        }
        if (!this.model.name && this.model.tenGoi) {
          this.model.name = this.model.tenGoi;
        }

        // Call Update API
        const payload = siteInfoModel.toJson(this.model);
        const res = await this.$store.dispatch("profession/infoSite/infoSiteStore/update", payload);

        if (res.code === 0) {
          this.$store.dispatch("snackBarStore/addNotify", {
            code: 0,
            message: "Lưu cấu hình thông tin lễ hội thành công!",
          });
          if (res.data) {
            this.model = siteInfoModel.fromJson(res.data);
          }
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            code: res.code,
            message: res.message,
          });
        }
      } catch (error) {
        console.error("Error saving site info:", error);
        this.$store.dispatch("snackBarStore/addNotify", {
          code: -1,
          message: "Lỗi kết nối khi lưu cấu hình thông tin lễ hội.",
        });
      } finally {
        this.isSaving = false;
        loader.hide();
      }
    },
  },
};
</script>

<style scoped>
/* ======================== CHỦ ĐỀ ECO-INSTITUTIONAL BENTO GRID ======================== */
.festival-info-container {
  padding: 0 12px;
  font-family: var(--font-body, "Inter"), sans-serif;
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

/* ======================== BỐ CỤC LƯỚI BENTO GRAPHICS ======================== */
.bento-layout-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 24px;
}

.bento-card {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(187, 202, 186, 0.3);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  transition: transform 0.25s, box-shadow 0.25s;
}

.bento-card:hover {
  box-shadow: 0 10px 20px rgba(13, 99, 27, 0.05);
}

/* Biến thể màu sắc Bento để tạo nhịp điệu thị giác */
.bento-bg-cream {
  background-color: var(--surface-cream, #FFF8E1);
  border-color: rgba(251, 140, 0, 0.15);
}

.bento-bg-light {
  background-color: rgba(241, 245, 235, 0.2);
}

.bento-bg-sage {
  background-color: var(--surface-container-low, #f1f5eb);
  border-color: rgba(13, 99, 27, 0.15);
}

/* Định nghĩa kích thước cột Bento trên Desktop */
.bento-col-8 {
  grid-column: span 12;
}

.bento-col-5 {
  grid-column: span 12;
}

.bento-col-4 {
  grid-column: span 12;
}

.bento-col-3 {
  grid-column: span 12;
}

@media (min-width: 992px) {
  .bento-col-8 {
    grid-column: span 8;
  }

  .bento-col-4 {
    grid-column: span 4;
  }

  .bento-col-5 {
    grid-column: span 5;
  }

  .bento-col-3 {
    grid-column: span 3;
  }

  .bento-row-span-2 {
    grid-row: span 2;
  }
}

/* ======================== CHI TIẾT THÀNH PHẦN CARD ======================== */
.card-header-premium {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.2);
  padding-bottom: 12px;
}

.icon-primary {
  color: var(--color-public-primary, #2e7d32);
  font-size: 20px;
}

.card-title-premium {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: var(--color-public-text-head, #1b5e20);
  margin: 0;
  text-align: left;
}

.bento-card-body {
  flex-grow: 1;
}

/* Form Input Premium */
.form-group-premium {
  margin-bottom: 16px;
  text-align: left;
}

.form-label-premium {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-public-text-body, #40493d);
  margin-bottom: 6px;
  display: block;
}

.premium-input {
  width: 100%;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  font-family: var(--font-body, "Inter"), sans-serif;
  color: var(--on-surface, #181d17);
  background-color: #ffffff;
  transition: all 0.2s ease-in-out;
  outline: none;
}

.premium-input:focus {
  border-color: var(--primary, #2e7d32);
  box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.12);
}

.input-icon-wrapper {
  position: relative;
}

.input-inner-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary, #2e7d32);
  font-size: 18px;
}

.ps-5 {
  padding-left: 44px !important;
}

textarea.premium-input {
  resize: vertical;
}

/* ======================== SWITCH CÔNG KHAI TÙY BIẾN ======================== */
.premium-switch-custom {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding-left: 0;
}

.premium-switch-custom .custom-control-input {
  position: absolute;
  left: 0;
  opacity: 0;
  z-index: -1;
}

.premium-switch-custom .custom-control-label {
  position: relative;
  padding-left: 48px;
  margin-bottom: 0;
  cursor: pointer;
  user-select: none;
}

.premium-switch-custom .custom-control-label::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 36px;
  height: 20px;
  background-color: var(--outline-variant, #bfcaba);
  border-radius: 10px;
  transition: background-color 0.2s ease;
}

.premium-switch-custom .custom-control-label::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 2px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.premium-switch-custom .custom-control-input:checked~.custom-control-label::before {
  background-color: var(--primary, #2e7d32);
}

.premium-switch-custom .custom-control-input:checked~.custom-control-label::after {
  transform: translate(16px, -50%);
}

.label-switch-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-public-text-body, #40493d);
}

/* ======================== UPLOAD AREA & IMAGE GRID ======================== */
.upload-trigger-box-custom {
  border: 2px dashed var(--outline-variant, #bfcaba);
  background-color: rgba(241, 245, 235, 0.4);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}

.upload-trigger-box-custom:hover {
  border-color: var(--primary, #2e7d32);
  background-color: rgba(46, 125, 50, 0.05);
}

.icon-upload {
  font-size: 28px;
  color: var(--primary, #2e7d32);
}

.upload-text-custom {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 13px;
  color: var(--primary, #2e7d32);
}

.upload-hint-custom {
  font-size: 10px;
  color: #888;
  margin-top: 2px;
}

/* Khối cuộn ảnh đã tải lên Bento-grid */
.bento-image-grid-scroll {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 280px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Đẹp hóa thanh cuộn */
.bento-image-grid-scroll::-webkit-scrollbar {
  width: 4px;
}

.bento-image-grid-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.bento-image-grid-scroll::-webkit-scrollbar-thumb {
  background: rgba(112, 122, 108, 0.2);
  border-radius: 4px;
}

.bento-image-item {
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: #ffffff;
  border: 1px solid rgba(187, 202, 186, 0.4);
  border-radius: 10px;
  gap: 12px;
}

.image-thumb-box {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.img-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-meta-info {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.image-filename {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.image-extension-tag {
  font-size: 9px;
  color: #888;
  text-transform: uppercase;
  font-weight: bold;
  margin-top: 2px;
}

.btn-remove-image-custom {
  background: none;
  border: none;
  color: var(--color-status-error, #d32f2f);
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  transition: background-color 0.15s;
}

.btn-remove-image-custom:hover {
  background-color: rgba(211, 47, 47, 0.08);
}

.empty-images-placeholder {
  text-align: center;
  padding: 40px 16px;
  color: rgba(55, 65, 81, 0.4);
  background-color: rgba(241, 245, 235, 0.2);
  border: 1px dashed var(--outline-variant, #bfcaba);
  border-radius: 12px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.placeholder-icon {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.5;
}

.empty-images-placeholder p {
  font-size: 12px;
  margin: 0;
  font-weight: 500;
}

/* ======================== CỤM NÚT ĐIỀU HƯỚNG / LƯU DASHBOARD (BENTO 5) ======================== */
.action-buttons-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-save-premium-dashboard {
  width: 100%;
  padding: 12px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
  transition: all 0.2s ease-in-out;
  outline: none;
}

.btn-save-premium-dashboard:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.25);
  transform: translateY(-1px);
}

.btn-save-premium-dashboard:disabled {
  background-color: #a5d6a7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-reload-premium-dashboard {
  width: 100%;
  padding: 12px;
  background-color: #ffffff;
  color: var(--color-public-text-body, #374151);
  border: 1px solid var(--outline-variant, #bfcaba);
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  outline: none;
}

.btn-reload-premium-dashboard:hover {
  background-color: #ffffff;
  border-color: var(--color-public-primary, #2e7d32);
  color: var(--color-public-primary, #2e7d32);
}
</style>